import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  newWorkflowTitle: {
    id: 'wKajJg',
    defaultMessage: 'New Workflow',
    description: 'Heading shown in the workflow drawer when creating a new workflow',
  },
  saveButton: {
    id: 'HnIGGW',
    defaultMessage: 'Save',
    description: 'Text for the save button in the workflow drawer (disabled until editor is implemented)',
  },
  closeDrawer: {
    id: 'D+bREP',
    defaultMessage: 'Close drawer',
    description: 'Aria label for the close button in the workflow drawer header',
  },
});
